import PropTypes from 'prop-types';
import Icon from 'components/elements/icon';
import { Button } from '@evertrue/et-components';

const EmailTemplate = ({ data, hideIcon, onClick = () => {} }) => (
  <div className="email-template">
    {hideIcon ? <div className="email-template--no-icon" /> : <Icon icon="email" className="email-template--icon" />}

    {!data?.email ? (
      <div className="email-template--data is-empty">Not provided</div>
    ) : (
      <div className="email-template--data">
        <div className="email-template--label">
          {data?.type || 'Other'}
          {data?.primary && ' (Primary)'}
        </div>

        <Button
          type="simple"
          className="email-template--button email-template--button-blue"
          onClick={() => {
            onClick(data.email);
          }}
        >
          {data.email}
        </Button>
      </div>
    )}
  </div>
);

EmailTemplate.propTypes = {
  data: PropTypes.object,
  hideIcon: PropTypes.bool,
  onClick: PropTypes.func,
};

export default EmailTemplate;
